module.exports = __webpack_public_path__ + "static/img/downloadpic@2x.8fdb474.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20180102/downloadpic@2x.png
// module id = 76
// module chunks = 1